import { createAction, props } from '@ngrx/store';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';

const adminUserLabels = {
  SET_RESULT: 'ADMIN_USER_SET_RESULT',
  SET_DEFAULT: 'ADMIN_USER_SET_DEFAULT',
  SET_ALL_DEFAULT: 'ADMIN_USER_SET_ALL_DEFAULT',
};

export const adminUserActions = {
  setResultAction: createAction(
    adminUserLabels.SET_RESULT,
    props<SecurityUserLoginModel>()
  ),
  setDefaultAction: createAction(
    adminUserLabels.SET_DEFAULT,
    props<SecurityUserLoginModel>()
  ),
  setAllDefaultAction: createAction(
    adminUserLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
